// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"54768519","354":"8f5d1fd7","515":"0c04111b","626":"3671f84c","664":"dced8da8","705":"636d6a34","784":"164ccd5c"}[chunkId] + ".chunk.css";
};